module.exports = __webpack_public_path__ + "b7d4b707a011471dced9cda604dba81b.svg";